import {  Autocomplete, InputProps, TextField } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import ViewAndEditModal from '../../components/viewAndEditModal/ViewAndEditModal';
import { IndentWrapper } from '../../features/orderConfiguration/OrderConfiguration';
import { RoleDivisionModalTypes } from '../../features/roleDivision/types';
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from '../../services/networkService';
import GenericMultiSelect from '../Input/GenericMultiSelect';
import { DashboardCheckbox } from '../Input/Input';
import './RoleDivisionModal.css'
import * as Sentry from "@sentry/react";
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

type roleAccessOptionsTypes= 'all'|'all'|'portal'
function RoleDivisionModal(props:{ params: RoleDivisionModalTypes}) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT = "Division"
    const {params}=props

    const arr:string[]=[];
    const [parent, setParent] = useState('');
    const [divisionName, setDivisionName] = useState(params.divisionName)
    const [parentOptions, setParentOptions] = useState<string[]>(arr)
    const [permissionGroup, setPermissionGroup] = useState<string[]>(arr)
    const [roleAccessType, setRoleAccessType] = useState<string>('all')

    const [permissionGroupOption, setPermissionGroupOption] = useState<{[key:string]:roleAccessOptionsTypes}>({})
    const [channelHierarchy, setChannelHierarchy] = useState<boolean>(params.channelHierarchy)
    const [showValidationMessage,setShowValidationMessage]=useState<boolean>(false);
    const [permissionValidation, setPermissionValidation] = useState<boolean>(false)
    function handleTextFieldChange(e:React.ChangeEvent<HTMLInputElement>) {
        setDivisionName(e.target.value)
        setShowValidationMessage(false);
    }

    function handleParentSelection(parentOptions:string[]){
        setParentOptions(parentOptions)
    }
    const handleEditParentSelection=(event:any,parentOption:string | null)=>{
        setParent(parentOption!);
    }
    function handlePermissionSelection(permissionOptions:string[]){
      setPermissionGroup(permissionOptions)
      let tempRoleAccessType='';
      permissionOptions.forEach((permission)=>{
        if(tempRoleAccessType===''){
          tempRoleAccessType=permissionGroupOption[permission]
        }else if(tempRoleAccessType!=permissionGroupOption[permission]){
          tempRoleAccessType='all';
        }
      })
      setRoleAccessType(tempRoleAccessType);
    }

    function handleCheckChange(e: React.ChangeEvent<HTMLInputElement>){
      setChannelHierarchy(e.target.checked)
    }

    const getPermissionGroup=async ()=>{
      //original divisions were coming from this
      try {
        const response = await ChannelkartNetworkGet('/v1/roles?source=portal&callType=scheduled')
        const data=response.data.features;
        let tempPermissionGroup:{}={};
        data.forEach((element:{name:string}) => {
          tempPermissionGroup={...tempPermissionGroup,[element.name]:'all'}
        });;
        setPermissionGroupOption(tempPermissionGroup);
      } catch (err) {
        console.log(`err: ${err}`)
        // Sentry.captureException(err);
      }


        //taking role names from config

        // try{
        //     let clientConfig = await (store.getState().serviceRegistry.get('ConfigurationService')).clientConfig.init();
        //     clientConfig = clientConfig.data
        //     let tempPermissionGroup:{}={};
        //     // let tempPermissionGroup:string[]=[];
        //     clientConfig.forEach( (element:{domainType:string,domainValues:any[]}) => {
        //       if(element.domainType.endsWith('_feature_configuration')){
        //         let roleName=element.domainType.split('_')[0]
        //         // roleName=roleName.split('_')[0];
        //         let tempRoleAccessType=element.domainType.split('_')[1];
        //         tempPermissionGroup={...tempPermissionGroup,[roleName]:tempRoleAccessType}
        //         // tempPermissionGroup.push(roleName);
        //       }
        //     });
        //     setPermissionGroupOption(tempPermissionGroup);
        // }catch(err){
        //     // Sentry.captureException(err);
        //     console.log("err===",err)
        // }
    }

    const setModalValues=()=>{
      setDivisionName(params.divisionName);
      setParentOptions([...parentOptions,params.parent]);
      setPermissionGroup(params.permissionGroup)
      setRoleAccessType(params.roleAccessType)
      setParent(params.parent);
    }

    useEffect(() => {
      getPermissionGroup()
      setModalValues()
    }, [])


    const addNewDivision=async ()=>{
      if(divisionName.length==0){
        setShowValidationMessage(true);
        return;
      }
      if(permissionGroup.length==0){
        setPermissionValidation(true)
        return;
      }

      try {
        
        const currentDate = dayjs(new Date()).format("YYYY-MM-DD HH:MM:ss");
        const permissionGroupString:string=permissionGroup.join(',');
        const parents:string=parentOptions.join(',');
        
        const payload=[
          {
            "permissionGroups": permissionGroupString,
            "roleAccessType": roleAccessType,
            "userHierarchy": divisionName,
            "reportingHierarchy": parents,//parents
            "isChannel": channelHierarchy,
            "extendedAttributes": {
              "activity": "divisionmgmt",
              "mobTime": currentDate, //format ->"2023-06-14 17:36:09"
              "designation": "admin"
            }
          }
        ]
        const response=await ChannelkartNetworkPost("/v1/divisions?transformer=Division&source=portal&callType=scheduled", payload);
        params.close()
        if(response.status==201){
          params.openPopup('Data Saved','Success')
          params.refreshPage();
        }else{
          params.openPopup('Something Went Wrong!','Error')
        }
      } catch (err) {
        params.close()
        params.openPopup('Something Went Wrong!','Error')
        console.log(err)
        // Sentry.captureException(err);
      }
    }

    const editDivision=async ()=>{
      if(permissionGroup.length==0){
        setPermissionValidation(true)
        return;
      }
      try {
      const permissionGroupString:string=permissionGroup.join(',');
      const payload={
        "id": params.id,
        "permissionGroups": permissionGroupString,
        "roleAccessType": roleAccessType,
        "userHierarchy": divisionName,
        "reportingHierarchy": parent,
        "isChannel": channelHierarchy,
      }
      const url=`/v1/divisions/${params.id}?transformer=Division&source=portal&callType=scheduled`
      const response=await ChannelkartNetworkPut(url, payload);
      params.close()
      if(response.status==200){
        params.openPopup('Data Saved','Success')
        params.refreshPage();
      }else {
        params.openPopup('Something Went Wrong','Error')
      }

      } catch (err) {
        console.log(`err: ${err}`)
        // Sentry.captureException(err);
      }
    }


    

  return (
    <div>
        
    <ViewAndEditModal
      closeModal={params.close}
      message={translate(TranslationEnum.common_portal,"Edit a record")}
      updateMethod={params.editDivision?editDivision:addNewDivision}
      check={true}
      // showLoader={showLoader}
    >
      <div className='role_division_modal_body'>
        <TextField
        className='division_name_input'
          label={`${translate(TranslationEnum.division,"Division Name")}*`}
          id="outlined-start-adornment"
          value={divisionName}
          onChange={handleTextFieldChange}
          InputProps={{ readOnly: params.editDivision } as InputProps}
          error={
            showValidationMessage
          }
          helperText={
            showValidationMessage
                ? "Please fill value"
                : ""
          }
        />
          {!params.editDivision && 
          <GenericMultiSelect options={params.possibleParents} label={translate(TranslationEnum.division,"Parent")} selectedOptions={parentOptions} handleMultiSelectState={handleParentSelection} isRequired={false} />}
          {params.editDivision && 
           <Autocomplete
              disablePortal
              value={parent}
              id="combo-box-demo"
              options={params.possibleParents}
              onChange={handleEditParentSelection}
              sx={{ width: '100%',margin:0 }}
              renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.division,"Role Access Type")} />}
            /> }
   
          <GenericMultiSelect options={Object.keys(permissionGroupOption)} label={`${translate(TranslationEnum.division,"Permission Group")}*`} selectedOptions={permissionGroup} handleMultiSelectState={handlePermissionSelection} isRequired={permissionValidation} errorMessage={"Please select value"}/>
          <IndentWrapper indent={2}>
            <DashboardCheckbox onChange={handleCheckChange} checked={channelHierarchy} label={translate(TranslationEnum.division,"Channel Hierarchy")} />
          </IndentWrapper>
          
      </div>
      
    
    </ViewAndEditModal>

     
    </div>
  )
}

export default RoleDivisionModal